<div class="container">
<div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
        <div class="form-group row">
            <label class="col-sm-5 col-form-label font18">Bedrooms</label>
            <div class="col-sm-7 mt-1">
                <!-- <select [(ngModel)]="bed_rooms" (change)="getBedrooms($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let bedroom of bedrooms" value={{bedroom}}>{{bedroom}}</option>
                </select> -->
                <ng-select
                    [items]="bedrooms"
                    placeholder="Select"
                    [searchable]="false" [clearable]="false"
                    (change)="getBedrooms(bed_rooms);" [(ngModel)]="bed_rooms">
                </ng-select>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-form-label font18">Bathrooms</label>
            <div class="col-sm-7 mt-1">
                <!-- <select [(ngModel)]="bath_rooms" (change)="getBathrooms($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let bathroom of bathrooms" value={{bathroom}}>{{bathroom}}</option>
                </select> -->
                <ng-select
                    [items]="bathrooms"
                    placeholder="Select"
                    [searchable]="false" [clearable]="false"
                    (change)="getBathrooms(bath_rooms);" [(ngModel)]="bath_rooms">
                </ng-select>
            </div>
        </div>
        <!-- <div class="form-group mt-3">
            <select [(ngModel)]="bed_rooms" (change)="getBedrooms($event)" class="dropdown-toggle form-control">
                <option value="Bedrooms" disabled selected>Bedrooms</option>
                <option *ngFor="let bedroom of bedrooms" value={{bedroom}}>{{bedroom}}</option>
            </select>
        </div>
        <div class="form-group mt-3">
            <select [(ngModel)]="bath_rooms" (change)="getBathrooms($event)" class="dropdown-toggle form-control">
                <option value="Bathrooms" disabled selected>Bathrooms</option>
                <option *ngFor="let bathroom of bathrooms" value={{bathroom}}>{{bathroom}}</option>
            </select>
        </div> -->
    </div>
    <button *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}" (click)="next();">Next</button>
</div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
        <div class="d-flex h-100 row col-sm-12 pr-0">
                <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row m-auto">
        <div class="form-group col-12 px-0 d-flex flex-wrap">
            <label class="col-5 col-form-label text-right">Bedrooms</label>
            <div class="col-7 mt-1">
                <!-- <select [(ngModel)]="bed_rooms" (change)="getBedrooms($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let bedroom of bedrooms" value={{bedroom}}>{{bedroom}}</option>
                </select> -->
                <ng-select
                    id="mob_bedrooms"
                    [items]="bedrooms"
                    placeholder="Select"
                     [clearable]="false"
                     [searchable]="true" 
                    (change)="getBedrooms(bed_rooms);" [(ngModel)]="bed_rooms"
                    
                    >
                </ng-select>
            </div>
        </div>
        <div class="form-group col-12 px-0 d-flex flex-wrap" style="margin-bottom:6px !important;">
            <label class="col-5 col-form-label text-right">Bathrooms</label>
            <div class="col-7 mt-1">
                <!-- <select [(ngModel)]="bath_rooms" (change)="getBathrooms($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let bathroom of bathrooms" value={{bathroom}}>{{bathroom}}</option>
                </select> -->
                <ng-select
                    [items]="bathrooms"
                    placeholder="Select"
                    [searchable]="true" 
                    [clearable]="false"
                    (change)="getBathrooms(bath_rooms);" [(ngModel)]="bath_rooms"
                  
                    >
                </ng-select>
            </div>
        </div>
        <br />
        <div style="width:94% !important; text-align: right;" class="mr-3">
            <div *ngIf="user_bot" class="ash_box text-right mt-2" >
                <h1 class="ansMob text-right" *ngIf="bed_rooms">Bedrooms: {{bed_rooms}}</h1>
                <h1 class="ansMob text-right" *ngIf="bath_rooms">Bathrooms: {{bath_rooms}}</h1>
            </div>
        </div>
        <!-- <div class="col-sm-10 text-left" *ngIf="showTyping">
            <img src="assets/images/typing-animated-gif-1.gif"/>
        </div> -->
    </div>
    <!-- <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-2 col-2 px-0 my-auto">
            <div class="arrow_box">
                <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
            </div>
        </div>
    </div> -->
</div>
<!-- <div class="btm-process webview">
    <div class="text-center" *ngIf="!messagetype">
      <span><img src="assets/images/active12.png"></span>
      <h4 class="clr333 processtxt">15% Completed</h4>
    </div>
    <div class="text-center" *ngIf="messagetype">
        <span><img src="assets/images/active8.png"></span>
        <h5 class="clr333 processtxt">40% Completed</h5>
      </div>
  </div> -->